"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var color_1 = __importDefault(require("@dicebear/avatars/lib/color")); // @ts-ignore


var initials_1 = __importDefault(require("initials"));

function default_1(random) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  options.backgroundColorLevel = options.backgroundColorLevel || 600;
  options.fontSize = options.fontSize || 50;
  options.chars = options.chars || 2;
  var backgroundColors = [];

  if (options.background) {
    backgroundColors.push(options.background);
    options.background = undefined;
  } else {
    Object.keys(color_1.default.collection).forEach(function (backgroundColor) {
      if (options.backgroundColors === undefined || options.backgroundColors.length === 0 || options.backgroundColors.indexOf(backgroundColor) !== -1) {
        backgroundColors.push(color_1.default.collection[backgroundColor][options.backgroundColorLevel]);
      }
    });
  }

  var backgroundColor = random.pickone(backgroundColors);
  var seedInitials = initials_1.default(random.seed.trim()).toLocaleUpperCase().slice(0, options.chars);
  var fontFamily = 'Arial,sans-serif'; // prettier-ignore

  var svg = ["<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" style=\"isolation:isolate;\" viewBox=\"0 0 1 1\" version=\"1.1\">", "<rect width=\"1\" height=\"1\" fill=\"".concat(backgroundColor, "\"></rect>"), options.margin ? "<g transform=\"translate(".concat(options.margin / 100, ", ").concat(options.margin / 100, ")\">") : '', options.margin ? "<g transform=\"scale(".concat(1 - options.margin * 2 / 100, ")\">") : '', "<text x=\"50%\" y=\"50%\" style=\"".concat(options.bold ? 'font-weight: bold;' : '', " font-family: ").concat(fontFamily, "; font-size: ").concat(options.fontSize / 100, "px\" fill=\"#FFF\" text-anchor=\"middle\" dy=\".178\">").concat(seedInitials, "</text>"), options.margin ? '</g>' : '', options.margin ? '</g>' : '', '</svg>'].join('');
  options.margin = undefined;
  return svg;
}

exports.default = default_1;